import React from 'react';
import { View, Text, StyleSheet, ScrollView, TextInput, TouchableOpacity, Dimensions, Linking } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';

const { width } = Dimensions.get('window');

const ContactScreen = () => {
    const { colors } = useTheme();
    const isMobile = width < 768;

    const [formData, setFormData] = React.useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });

    const contactInfo = [
        { icon: 'location', title: 'Address', value: 'C Block, Jansukh, India' },
        { icon: 'call', title: 'Phone', value: '+91 92118 99902', action: () => Linking.openURL('tel:+919211899902') },
        { icon: 'mail', title: 'Email', value: 'shubham@modernmunshiji.com', action: () => Linking.openURL('mailto:shubham@modernmunshiji.com') },
    ];

    const handleSubmit = () => {
        const mailtoUrl = `mailto:shubham@modernmunshiji.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\n${formData.message}`)}`;
        Linking.openURL(mailtoUrl);
    };

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 16,
            color: 'rgba(255,255,255,0.8)',
            textAlign: 'center',
            maxWidth: 600,
        },
        content: {
            padding: 20,
            maxWidth: 1100,
            alignSelf: 'center',
            width: '100%',
        },
        row: {
            flexDirection: isMobile ? 'column' : 'row',
            gap: 40,
        },
        contactInfoSection: {
            flex: isMobile ? undefined : 1,
        },
        formSection: {
            flex: isMobile ? undefined : 1.5,
        },
        sectionTitle: {
            fontSize: 24,
            fontWeight: '700',
            color: colors.text,
            marginBottom: 20,
        },
        infoCard: {
            backgroundColor: colors.surface,
            borderRadius: 12,
            padding: 20,
            marginBottom: 16,
            flexDirection: 'row',
            alignItems: 'center',
            borderWidth: 1,
            borderColor: colors.border,
        },
        infoIcon: {
            width: 48,
            height: 48,
            borderRadius: 24,
            backgroundColor: '#1a1a4e',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 16,
        },
        infoTitle: {
            fontSize: 13,
            color: colors.textSecondary,
            marginBottom: 4,
        },
        infoValue: {
            fontSize: 15,
            color: colors.text,
            fontWeight: '600',
        },
        formCard: {
            backgroundColor: colors.surface,
            borderRadius: 12,
            padding: 24,
            borderWidth: 1,
            borderColor: colors.border,
        },
        inputRow: {
            flexDirection: isMobile ? 'column' : 'row',
            gap: 16,
            marginBottom: 16,
        },
        inputGroup: {
            flex: 1,
        },
        label: {
            fontSize: 14,
            fontWeight: '600',
            color: colors.text,
            marginBottom: 8,
        },
        input: {
            backgroundColor: colors.background,
            borderWidth: 1,
            borderColor: colors.border,
            borderRadius: 8,
            paddingHorizontal: 16,
            paddingVertical: 12,
            fontSize: 15,
            color: colors.text,
        },
        textArea: {
            height: 120,
            textAlignVertical: 'top',
        },
        submitButton: {
            backgroundColor: '#c9a44e',
            paddingVertical: 16,
            borderRadius: 8,
            alignItems: 'center',
            marginTop: 8,
        },
        submitButtonText: {
            color: '#1a1a4e',
            fontWeight: '700',
            fontSize: 16,
        },
        socialSection: {
            marginTop: 30,
        },
        socialTitle: {
            fontSize: 16,
            fontWeight: '600',
            color: colors.text,
            marginBottom: 16,
        },
        socialRow: {
            flexDirection: 'row',
            gap: 12,
        },
        socialButton: {
            width: 44,
            height: 44,
            borderRadius: 22,
            backgroundColor: '#1a1a4e',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <Text style={styles.heroTitle}>Contact Us</Text>
                    <Text style={styles.heroSubtitle}>
                        Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                    </Text>
                </View>

                <View style={styles.content}>
                    <View style={styles.row}>
                        <View style={styles.contactInfoSection}>
                            <Text style={styles.sectionTitle}>Get in Touch</Text>
                            {contactInfo.map((info, index) => {
                                const Card = info.action ? TouchableOpacity : View;
                                return (
                                    <Card key={index} style={styles.infoCard} onPress={info.action} activeOpacity={0.7}>
                                        <View style={styles.infoIcon}>
                                            <Ionicons name={info.icon} size={22} color="#c9a44e" />
                                        </View>
                                        <View>
                                            <Text style={styles.infoTitle}>{info.title}</Text>
                                            <Text style={styles.infoValue}>{info.value}</Text>
                                        </View>
                                    </Card>
                                );
                            })}

                            <View style={styles.socialSection}>
                                <Text style={styles.socialTitle}>Follow Us</Text>
                                <View style={styles.socialRow}>
                                    <TouchableOpacity style={styles.socialButton} onPress={() => Linking.openURL('https://facebook.com')}>
                                        <Ionicons name="logo-facebook" size={20} color="#c9a44e" />
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.socialButton} onPress={() => Linking.openURL('https://twitter.com')}>
                                        <Ionicons name="logo-twitter" size={20} color="#c9a44e" />
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.socialButton} onPress={() => Linking.openURL('https://linkedin.com')}>
                                        <Ionicons name="logo-linkedin" size={20} color="#c9a44e" />
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.socialButton} onPress={() => Linking.openURL('https://instagram.com')}>
                                        <Ionicons name="logo-instagram" size={20} color="#c9a44e" />
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </View>

                        <View style={styles.formSection}>
                            <Text style={styles.sectionTitle}>Send a Message</Text>
                            <View style={styles.formCard}>
                                <View style={styles.inputRow}>
                                    <View style={styles.inputGroup}>
                                        <Text style={styles.label}>Your Name</Text>
                                        <TextInput
                                            style={styles.input}
                                            placeholder="Enter your name"
                                            placeholderTextColor={colors.textSecondary}
                                            value={formData.name}
                                            onChangeText={(text) => setFormData({ ...formData, name: text })}
                                        />
                                    </View>
                                    <View style={styles.inputGroup}>
                                        <Text style={styles.label}>Email Address</Text>
                                        <TextInput
                                            style={styles.input}
                                            placeholder="Enter your email"
                                            placeholderTextColor={colors.textSecondary}
                                            keyboardType="email-address"
                                            value={formData.email}
                                            onChangeText={(text) => setFormData({ ...formData, email: text })}
                                        />
                                    </View>
                                </View>
                                <View style={styles.inputRow}>
                                    <View style={styles.inputGroup}>
                                        <Text style={styles.label}>Phone Number</Text>
                                        <TextInput
                                            style={styles.input}
                                            placeholder="Enter your phone"
                                            placeholderTextColor={colors.textSecondary}
                                            keyboardType="phone-pad"
                                            value={formData.phone}
                                            onChangeText={(text) => setFormData({ ...formData, phone: text })}
                                        />
                                    </View>
                                    <View style={styles.inputGroup}>
                                        <Text style={styles.label}>Subject</Text>
                                        <TextInput
                                            style={styles.input}
                                            placeholder="What's this about?"
                                            placeholderTextColor={colors.textSecondary}
                                            value={formData.subject}
                                            onChangeText={(text) => setFormData({ ...formData, subject: text })}
                                        />
                                    </View>
                                </View>
                                <View style={{ marginBottom: 16 }}>
                                    <Text style={styles.label}>Message</Text>
                                    <TextInput
                                        style={[styles.input, styles.textArea]}
                                        placeholder="Write your message here..."
                                        placeholderTextColor={colors.textSecondary}
                                        multiline
                                        value={formData.message}
                                        onChangeText={(text) => setFormData({ ...formData, message: text })}
                                    />
                                </View>
                                <TouchableOpacity style={styles.submitButton} onPress={handleSubmit}>
                                    <Text style={styles.submitButtonText}>Send Message</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default ContactScreen;
